import naturalCompare from 'natural-compare';

export default function compareMultiType(x, y, direction = "asc") {
  // Handle null/undefined values - nulls come first
  if (x == null && y == null) return 0;
  if (x == null) return -1;
  if (y == null) return 1;

  // Handle empty strings - empty strings come first
  if (x === "" && y === "") return 0;
  if (x === "") return -1;
  if (y === "") return 1;

  // Handle special "Perpetual" values - they come last
  if (x === "Perpetual" && y === "Perpetual") return 0;
  if (x === "Perpetual") return 1;
  if (y === "Perpetual") return -1;

  // Convert to strings for consistent comparison
  const strX = String(x);
  const strY = String(y);

  // Handle percentage values by extracting numeric part
  const isPercentageX = strX.endsWith('%');
  const isPercentageY = strY.endsWith('%');
  
  if (isPercentageX && isPercentageY) {
    const numX = parseFloat(strX.slice(0, -1));
    const numY = parseFloat(strY.slice(0, -1));
    const result = numX < numY ? -1 : numX > numY ? 1 : 0;
    return direction === "asc" ? result : -result;
  }

  // Handle date format dd-mm-yyyy
  const dateRegex = /^(\d{2})-(\d{2})-(\d{4})$/;
  const isDateX = dateRegex.test(strX);
  const isDateY = dateRegex.test(strY);
  
  if (isDateX && isDateY) {
    const matchX = strX.match(dateRegex);
    const matchY = strY.match(dateRegex);
    const dateX = new Date(matchX[3], matchX[2] - 1, matchX[1]);
    const dateY = new Date(matchY[3], matchY[2] - 1, matchY[1]);
    const result = dateX < dateY ? -1 : dateX > dateY ? 1 : 0;
    return direction === "asc" ? result : -result;
  }

  // Use natural-compare for all other cases (handles numbers, strings, mixed types)
  const result = naturalCompare(strX, strY);
  return direction === "asc" ? result : -result;
}